import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=f50128d4&scoped=true&"
var script = {}
import style0 from "./operate.vue?vue&type=style&index=0&id=f50128d4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50128d4",
  null
  
)

export default component.exports